'use client';
import { useLanguage } from '@/lib/i18n/LanguageContext';
export function NotWorkingCheckbox({ checked, onChange, disabled }: { checked: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  const { t } = useLanguage();
  return (
    <label className="inline-flex items-center gap-2 text-sm text-gray-700">
      <input type="checkbox" checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)} className="h-4 w-4 rounded border-gray-300" />
      {t('profile.notWorking')}
    </label>
  );
}
